import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62876247"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}

import { computed } from "vue";
import { useRouter } from "vue-router";
import { MobileNavigationBarIconType } from "@/types/app";
import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import { MobileNavigationProps } from "@/types/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNavigationBar',
  props: {
    hideDivider: { type: Boolean, default: false },
    title: { default: "" },
    handleRedirect: { type: Function, default: undefined },
    handleAction: { type: Function, default: undefined },
    actionTitle: { default: "" },
    iconType: { default: MobileNavigationBarIconType.Default },
    isActionDisabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const router = useRouter();

const props = __props;

const appliedIconName = computed(() => {
  switch (props.iconType) {
    case MobileNavigationBarIconType.Circle:
      return IconType.BACK_CIRCLE;

    default:
      return IconType.BACK;
  }
});

const handleClick = () => {
  if (props.handleRedirect) {
    props.handleRedirect();
    return;
  }

  router.back();
};

const performAction = () => {
  if (props.isActionDisabled || !props.handleAction) {
    return;
  }
  props.handleAction();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "back",
      onClick: handleClick
    }, [
      _createVNode(Icon, {
        icon: appliedIconName.value,
        class: "icon"
      }, null, 8, ["icon"])
    ]),
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("h4", _hoisted_2, _toDisplayString(_ctx.title), 1))
      : _createCommentVNode("", true),
    (_ctx.handleAction)
      ? (_openBlock(), _createElementBlock("p", {
          key: 1,
          class: _normalizeClass(["btn", { disabled: _ctx.isActionDisabled }]),
          onClick: performAction
        }, _toDisplayString(_ctx.actionTitle), 3))
      : _createCommentVNode("", true)
  ]))
}
}

})